export const TRANSACTION_TYPES = [
  "Visa",
  "IELTS",
  "TOEFL",
  "PTE",
  "OET",
  "English-Other",
  "Admission",
  "Banking",
  "Telecommunication",
  "Document Support",
  "Travel",
  "Insurance",
  "Accommodation",
  "Other",
];

export const CONTRACT_CATEGORIES = [
  "NCT owned and operated",
  "Contracted owned and operated",
  "Contractor owned but NCT operated",
];

export const medical_certification = ["Valid", "Expired"];
export const licenceTypeOptions = ["Commercial", "Private", "Government"];
export const licenceStatusOptions = ["Valid", "Expired"];

export const TRANSACTION_APPLICANT_TYPES = ["Single", "Couple", "Family"];

export const VISA_DECISIONS = ["Granted", "Refused"];

export const LODGEMENT_STATUS = ["Lodged", "Not Lodged", "Withdrawn"];

export const AUSTRALIA_STATES = [
  "ACT",
  "NSW",
  "NT",
  "QLD",
  "SA",
  "TAS",
  "VIC",
  "WA",
];

export const EDUCATION_SECTORS = [
  "Foreign Affairs or Defence Sector",
  "Higher Education Sector",
  "Independent ELICOS Sector",
  "Non-Award Sector",
  "Postgraduate Research Sector",
  "Schools Sector",
  "Vocational Education and Training Sector",
];

export const AGE_GROUPS = [
  "0 to 4 years",
  "5 to 9 years",
  "10 to 14 years",
  "15 to 19 years",
  "20 to 24 years",
  "25 to 29 years",
  "30 to 34 years",
  "35 to 39 years",
  "40 to 44 years",
  "45 to 49 years",
  "50 to 54 years",
  "55 and over",
  "Not Specified",
];

export const APPLICATION_TYPES = [
  "College-List",
  "College-Manual-Enter",
  "Insurance",
  "Accommodation",
  "College-List-Refund",
  "Insurance-Refund",
  "Other",
];

export const APPLICATION_PRIORITY_OPTIONS = ["Low", "Normal", "High"];

export const APPLICATION_LOCATIONS = ["Onshore", "Offshore"];

export const RESPONSIBLE_SOURCES = ["User", "Team"];

export const CIVIL_STATUSES = [
  "Single",
  "Married",
  "De Facto",
  "Separated",
  "Widowed",
];

export const NOTE_TYPES = ["Note", "Call", "Meeting", "Email", "Other"];

export const TRACKER_DURATIONS = [3, 5, 14];

export const MONITORING_DURATION = [7, 14, 30];

export const TASK_CATEGORIES = [
  "Reminder",
  "Call",
  "Follow Up",
  "Email",
  "Meeting",
  "Others",
];

export const TASK_PRIORITIES = ["Low", "Normal", "High", "Urgent"];

export const TASK_ASSIGNEE_TYPES = [
  "General",
  "Client",
  "Transaction",
  "Application",
  "University",
  "Course",
];

export const KPI_STAGES = [
  "Partner Colleges",
  "Courses Updated",
  "Inquiries",
  "Leads Generated",
  "Clients Converted",
  "Study Options Issued",
  "Transactions Opened",
  "Offer Letters Issued",
  "COEs Issued",
  "Visa Lodgements",
  "Visa Grants",
];

export const USER_TYPES = [
  "System",
  "Customer",
  "Contractor",
  "VendorProfile",
  "Driver",
          "VendorStaff",
];

export const ACCOUNT_TYPES = ["System", "College"];
export const CONTRACTOR_TYPES = [
  "NCT owned and operated",
  "Contracted owned and operated",
  "Contractor owned but NCT operated",
];
export const VEHICLE_MAINTENANCE_TYPES = ["Regular", "Emergency"];
export const VEHICLE_MAINTENANCE_CONDITIONS = ["Needs Major Repair", "Good"];
export const VEHICLE_TYPE = ["Truck", "Van"];
export const SHIPMENT_STATUS_TYPE = [
  "Pending",
  "Collected",
  "Loaded",
  "Delivered",
];
export const SHIPMENT_DELIVERY_TYPES = ["Express", "Regular", "By Air"];
export const SHIPMENT_DELIVERY = ["Door Delivery", "Branch Delivery"];

export const SHIPMENT_FD_STATUS = ["Valid", "Expired", "Pending"];
export const CROSS_DOCKING_STATUS = [
  "Pending",
  "In Progress",
  "Completed",
  "Cancelled",
];
export const COMMUNICATION_STATUS = ["Pending", "Completed", "Failed"];
export const COMMUNICATION_TYPE = ["Note", "Document", "Comment", "Other"];
export const COMPLIANCE_STATUS = ["Pending", "Cleared", "Rejected"];
export const CONSOLIDATION_TYPE = ["Origin", "Transit", "Destination"];
export const DECONSOLIDATION_TYPE = ["Transit", "Destination"];
export const CONSOLIDATION_LOAD_TYPE = ["FTL", "HTL", "PTL", "Other"];

export const COLLECTION_MODE = ["Cash", "Bank Transfer"];

export const FUEL_TYPES = ["Petrol", "Diesel"];

export const PAYMENT_TERMS_OPTIONS = ["Retail", "Contract"];
